import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import StorefrontLayout from "../../components/storefront/StorefrontLayout";
import { api } from "../../lib/api";

export function Blogs() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/api/blogs").then((r) => setItems(r.data || [])); }, []);
  return (
    <StorefrontLayout>
      <div className="px-6 lg:px-12 py-10">
        <div className="eyebrow">Journal</div>
        <h1 className="font-display text-5xl text-maroon mt-1">From the House of Swayambhu</h1>
        <div className="royal-divider my-8"/>
        {items.length === 0 ? (
          <div className="text-center py-20 text-ash">No blogs yet.</div>
        ) : (
          <div className="grid lg:grid-cols-3 gap-6">
            {items.map((b) => (
              <Link key={b.id} to={`/blog/${b.slug}`} className="block hover-lift" data-testid={`blogs-item-${b.slug}`}>
                <div className="zoom-frame aspect-[4/3] border border-line">
                  <img src={b.cover_image || "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=900&q=85"} alt={b.title} className="w-full h-full object-cover" />
                </div>
                <div className="mt-3 eyebrow text-[10px]">{(b.tags || []).join(" · ")}</div>
                <div className="font-display text-2xl text-maroon mt-1">{b.title}</div>
                <p className="text-sm text-ash mt-1 line-clamp-2">{b.excerpt}</p>
              </Link>
            ))}
          </div>
        )}
      </div>
    </StorefrontLayout>
  );
}

export function BlogDetail() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  useEffect(() => { api.get(`/api/blogs/${slug}`).then((r) => setBlog(r.data)).catch(() => {}); }, [slug]);
  if (!blog) return <StorefrontLayout><div className="px-12 py-24 text-center text-ash">Loading…</div></StorefrontLayout>;
  return (
    <StorefrontLayout>
      <article className="max-w-3xl mx-auto px-6 py-12">
        <div className="eyebrow">{(blog.tags || []).join(" · ")}</div>
        <h1 className="font-display text-5xl text-maroon mt-2">{blog.title}</h1>
        <div className="text-xs text-ash mt-2">{blog.author_name} · {new Date(blog.created_at).toLocaleDateString()}</div>
        {blog.cover_image && <img src={blog.cover_image} alt="" className="w-full mt-8 aspect-[16/9] object-cover"/>}
        <div className="prose mt-8 text-ink" dangerouslySetInnerHTML={{ __html: blog.content }} />
        {blog.images?.length > 0 && (
          <div className="grid grid-cols-2 gap-3 mt-8">
            {blog.images.map((img, i) => <img key={i} src={img} alt="" className="w-full aspect-square object-cover" />)}
          </div>
        )}
      </article>
    </StorefrontLayout>
  );
}
